import React, { useEffect, useState } from "react";
import InputLayout from "./InputLayout";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import { RadioButton } from "primereact/radiobutton";
import { MultiSelect } from "primereact/multiselect";
import { Avatar } from "primereact/avatar";
import { Ripple } from "primereact/ripple";

export function CustomForm({ children, extraclass, ...props }) {
    return (
        <div className={`grid grid-nogutter ${extraclass}`} {...props}>
            {children}
        </div>
    );
}

export const CustomInput = ({ label, name, data, value, onChange, errorMessage, extraClassName, labelClassName, required, col, inputClass, disabled = false, type = "text", ...props }) => {
    return (
        <InputLayout col={col || 6} label={label} name={name} required={required} extraClassName={extraClassName} labelClassName={labelClassName} data={data} errorMessage={errorMessage}>
            <InputText
                id={name}
                name={name}
                value={value}
                type={type}
                onChange={(e) => onChange && onChange({ ...e, name: e.target.name, value: e.target.value })}
                className={`custom-input text-sm w-full border-round-xl  bg-transparent ${inputClass ? inputClass : ""} ${errorMessage || data?.["formErrors"]?.[name] ? "p-invalid" : ""}`}
                disabled={disabled}
                {...props}
            />
        </InputLayout>
    );
};

export const CustomSearch = ({ name, data, value, onChange, iconPosition = "p-input-icon-left", col, inputClass, ...props }) => {
    return (
        <span className={`w-full bg-white ${iconPosition}`}>
            <i className="pi pi-search" />
            <InputText
                id={name}
                name={name}
                value={value}
                type="text"
                onChange={(e) => onChange && onChange(e.target.value)}
                className={`custom-input text-sm w-full border-round-xl  bg-transparent ${inputClass ? inputClass : ""}`}
                placeholder="Search"
                {...props}
            />
        </span>
    );
};

export function CustomCheckbox({ label, name, onChange, data, checked, value, disable, errorMessage, extraClassName, required, extraclass, col, inputClass, optionLabel, optionclass, ...props }) {
    return (
        <InputLayout col={col || 12} label={label} name={name} required={required} extraClassName={extraClassName} data={data} errorMessage={errorMessage}>
            <div className={`flex align-items-center text-md text-gray font-medium mb-3 ${extraclass}`}>
                <Checkbox
                    checked={value || data?.[name]}
                    icon="pi pi-check-square"
                    className={value ? "border-none" : ""}
                    onChange={(e) => onChange && onChange({ ...e, name, value: e.checked })}
                    id={name}
                    name={name}
                    {...props}
                    disabled={disable}
                />
                {optionLabel ? (
                    <>
                        &nbsp;&nbsp;
                        <label className={`text-white text-sm font-medium ${optionclass}`} htmlFor={name}>
                            {optionLabel}
                        </label>
                    </>
                ) : null}
            </div>
        </InputLayout>
    );
}

export const CustomOtp = ({ label, name, onChange, data, value, errorMessage, extraClassName, required, col, inputClass, disabled = false, optionLabel = "name", ...props }) => {
    return (
        <InputLayout col={col || 6} label={label} name={name} required={required} extraClassName={extraClassName} data={data} errorMessage={errorMessage}>
            
            {errorMessage ? <small className="p-error">{errorMessage}</small> : null}
        </InputLayout>
    );
};
export const CustomCalenderInput = ({ label, name, data, value, onChange, errorMessage, extraClassName, required, col, inputClass, ...props }) => {
    return (
        <InputLayout col={col || 6} label={label} name={name} required={required} extraClassName={extraClassName} data={data} errorMessage={errorMessage}>
            <Calendar
                id={name}
                name={name}
                value={value || data?.[name]}
                onChange={(e) => onChange && onChange({ ...e, name: e.target.name, value: e.target.value })}
                className={`custom-input text-sm w-full border-round-lg  bg-transparent ${inputClass ? inputClass : "text-sm"} ${errorMessage || data?.["formErrors"]?.[name] ? "p-invalid" : ""}`}
                showIcon
                dateFormat="dd/mm/yy"
                {...props}
            />
        </InputLayout>
    );
};
export const CustomCalenderIcon = ({ label, name, data, value, onChange, errorMessage, extraClassName, filterKey, required, col, inputClass, ...props }) => {
    return (
        <div className="flex gap-2 align-items-center">
            <p className="min-w-max">{filterKey}</p>
            <label
                htmlFor="dateRange"
                className={`bg-light border block flex align-items-center justify-content-center cursor-pointer ${value ? "border-primary bg-primary" : ""}`}
                style={{ minWidth: "40px", minHeight: "40px" }}
            >
                <i className={`pi pi-calendar text-primary text-xl  ${value ? "text-white font-normal" : "font-semibold"}`} />
            </label>
            <Calendar
                inputId="dateRange"
                name="dateRange"
                value={value || data?.[name]}
                onChange={(e) => onChange && onChange(e.target.value)}
                className={` ${inputClass ? inputClass : "opacity-0"}`}
                inputClassName="p-0"
                style={{ width: 0 }}
                selectionMode="range"
                readOnlyInput
                showButtonBar
                {...props}
            />
        </div>
    );
};
export const CustomInputNumber = ({ label, name, data, value, onChange, labelClassName, errorMessage, maxValue, extraClassName, required, col, inputClass, ...props }) => {
    return (
        <InputLayout col={col || 6} label={label} name={name} required={required} labelClassName={labelClassName} extraClassName={extraClassName} data={data} errorMessage={errorMessage}>
            <InputNumber
                id={name}
                name={name}
                value={value || data?.[name] || null}
                onValueChange={(e) => onChange && onChange({ ...e, name: e.target.name, value: e.value })}
                className={`custom-input text-sm w-full border-round-lg  bg-transparent ${inputClass ? inputClass : ""} ${errorMessage || data?.["formErrors"]?.[name] ? "p-invalid" : ""}`}
                useGrouping={props.useGrouping || false}
                {...props}
                max={maxValue}
            />
            {errorMessage ? <small className="p-error">{errorMessage}</small> : null}
        </InputLayout>
    );
};
export const CustomTextArea = ({ label, name, onChange, data, value, errorMessage, extraClassName, required, col, maxLength, inputClass, disabled = false, ...props }) => {
    const [currentLength, setLength] = useState(0);
    const handleTextArea = (e) => {
        onChange && onChange({ name: e.target.name, value: e.target.value, ...e });
        setLength(e.target.value.length);
    };

    useEffect(() => {
        if (value) setLength(value.length);
        else setLength(0);
    }, [value]);
    return (
        <InputLayout
            col={col || 12}
            label={label}
            currentLength={currentLength}
            name={name}
            maxLength={maxLength}
            required={required}
            extraClassName={extraClassName}
            data={data}
            errorMessage={errorMessage}
        >
            <InputTextarea
                id={name}
                name={name}
                value={value}
                onChange={(e) => handleTextArea(e)}
                className={`w-full border-round-lg ${inputClass ? inputClass : ""} ${errorMessage ? "p-invalid" : ""}`}
                disabled={disabled}
                {...props}
                maxLength={maxLength}
            />
            {errorMessage ? <small className="p-error">{errorMessage}</small> : null}
        </InputLayout>
    );
};

export const CustomDropDown = ({ label, name, onChange, data, value, errorMessage, extraClassName, required, col, inputClass, disabled = false, optionLabel = "name", ...props }) => {
    return (
        <InputLayout col={col || 12} label={label} name={name} required={required} extraClassName={extraClassName} data={data} errorMessage={errorMessage}>
            <Dropdown
                id={name}
                name={name}
                value={value || data?.[name]}
                onChange={(e) => onChange && onChange({ ...e, name: e.target.name, value: e.value })}
                className={`w-full border-round-lg text-sm ${inputClass ? inputClass : ""} ${errorMessage || data?.["formErrors"]?.[name] ? "p-invalid" : ""}`}
                optionLabel={optionLabel}
                placeholder={props.placeholder || `Select ${label}`}
                disabled={disabled}
                {...props}
            />
            {/* {errorMessage ? <small className="p-error">{errorMessage}</small> : null} */}
        </InputLayout>
    );
};

export const CustomMultiSelect = ({ label, name, onChange, data, value, options, errorMessage, extraClassName, required, col, inputClass, ...props }) => {
    return (
        <InputLayout col={col || 12} label={label} name={name} required={required} extraClassName={extraClassName} data={data} errorMessage={errorMessage}>
            <MultiSelect
                id={name}
                name={name}
                value={options.length ? value || data?.[name] : []}
                onChange={(e) => onChange && onChange({ ...e, name: e.target.name, value: e.value })}
                className={`w-full ${inputClass ? inputClass : ""} ${errorMessage ? "p-invalid" : ""}`}
                optionLabel="name"
                options={options}
                display="chip"
                placeholder={props.placeholder || `Select ${label}`}
                {...props}
            />
            {errorMessage ? <small className="p-error">{errorMessage}</small> : null}
        </InputLayout>
    );
};

